// extracted by mini-css-extract-plugin
module.exports = {"sbylaz5":"sbylaz5"};